import { ActionType } from 'typesafe-actions';
import get from 'lodash/get';

import * as Actions from './actions';
import * as Constants from './constants';
import * as Mappers from './mappers';
import * as Types from './types';

const initialState: Types.IState = {
  list: {
    all: {
      items: [],
      isFetched: false,
      isLoaded: false,
      meta: {
        current: 1,
        total: 1
      }
    }
  },
  single: {
    item: Mappers.applicationSingle(),
    isFetched: false
  }
};

export default (state: Types.IState = initialState, action: ActionType<typeof Actions>): Types.IState => {
  switch (action.type) {
    case Constants.LIST.REQUEST: {
      const { name, params } = action.payload;

      const list = state.list[name] || {};
      let isLoaded = !!list.isLoaded;
      if(get(list, 'meta.current') !== params.page){
        isLoaded = false;
      }

      return {
        ...state,
        list: {
          ...state.list,
          [name]: {
            ...list,
            items: list.items || [],
            isFetched: false,
            isLoaded
          }
        }
      };
    }
    case Constants.LIST.SUCCESS: {
      const { name, items, meta } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          [name]: {
            ...(state.list[name] || {}),
            items,
            meta,
            isFetched: true,
            isLoaded: true
          }
        }
      };
    }
    case Constants.LIST.FAILURE: {
      const { name } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          [name]: {
            ...(state.list[name] || {}),
            isFetched: true,
            isLoaded: true
          }
        }
      };
    }
    case Constants.SINGLE.REQUEST: {
      return {
        ...state,
        single: {
          ...state.single,
          isFetched: false
        }
      };
    }
    case Constants.SINGLE.SUCCESS: {
      const { item } = action.payload;
      return {
        ...state,
        single: {
          ...state.single,
          item,
          isFetched: true
        }
      };
    }
    case Constants.SINGLE.FAILURE: {
      return {
        ...state,
        single: {
          ...state.single,
          isFetched: true
        }
      };
    }
    case Constants.STORE_RESET: {
      return {
        ...state,
        ...initialState
      }
    }
    default:
      return state;
  }
}